import img1 from '../../images/slide-image-1_1728x.jpg';
import img2 from '../../images/slide-image-2_1728x.jpg';
// import img3 from '../../images/slide-image-3_1728x.jpg';
const mainBanners = [
  {
    title: 'Neck Ribbed Dress',
    subtitle: 'fashion',
    description: 'You’ll always be in fashion with our collection of clothing',
    href: '/product/61cace6542c43032ccd55c6d',
    buttonTitle: 'Shop Now',
    img: img1,
    textSide: 'left',
  },
  {
    title: 'Icon Bomber Jacket',
    subtitle: 'fashion',
    description: 'You’ll always be in fashion with our collection of clothing',
    href: '/product/61cacf6142c43032ccd55ce7',
    img: img2,
    textSide: 'left',
    buttonTitle: 'Shop Now',
  },
  // {
  //   title: 'Denim Perfect3',
  //   subtitle: 'fashion guide3',
  //   description: 'You’ll always be in fashion with our collection of clothing',
  //   href: '/manageOrders',
  //   img: img3,
  //   textSide: 'center',
  //   buttonTitle: 'Shop Now',
  // },
];

export default mainBanners;